const androidEmmRegistrationLabel = {
  enterprises: 'Enterprise',
  clientID: 'Client ID',
  companyEmailAddress: 'Company Email Address',
  dateAndTime: 'Date and Time',
  status: 'Status',
};

const androidEmmRegistrationText = {
  title: 'Android EMM Registration',
  label: androidEmmRegistrationLabel,
};

const androidEmmUserConfigText = {
  title: 'User Android Configuration',
  text: 'You can control if a user\'s personal Android device can enroll in JumpCloud\'s Android EMM to access company resources. Select Allow users to enroll mobile devices, and instruct the user to log into the User Portal and go to Security > Enroll Your Android Device. After the user scans a QR code to enroll the device in EMM, the enrolled Android device is visible in the Admin Portal.',
  checkBoxText: 'Allow Users to enroll personal mobile devices and access **Enroll your Android Device** in the User Portal.',
};

const androidEmmAdminConfigText = {
  title: 'Admin Android Configuration',
  text: 'Enroll a company-owned Android device in Android EMM by clicking **View QR Code** and following the prompts to enroll the device in EMM. The enrolled Android device is visible in the Admin portal. Deliver the device to the user and the user can immediately access company resources, such as email, calendar, contacts and documents.',
  buttonText: 'View QR Code',
};

const enrollmentFirstCard = {
  title: 'Android EMM',
  text: '**JumpCloud Android EMM** enables you to seamlessly consolidate your Android device management (both desktops and mobility) in order to reduce time, costs, and resources',
};

const enrollmentSecondCard = {
  title: 'Key Features',
  text: ['Device Provisioning', 'Device Security', 'Application Management', 'Device Management', 'Account Management'],
};

const enrollmentThirdCard = {
  title: 'Key Benefits',
  text: ['Minimized Security Risks', 'Enhanced End User Privacy', 'Decreased IT Administration', 'Increased Productivity, and Lower User Friction'],
};

const enrollmentInstructions = {
  startClickButton: 'Click **Begin Enrollment**.',
  signInGoogleAccount: 'Enter your company’s Google account, then click **Save**. This account can be a standard Gmail account but Google recommends that you create a new Google account.',
  enterBusinessName: 'Enter your company’s name, then click **Next**.',
  enterContactDetails: 'Enter contact details for your company, select **I have read and agree to the Managed Google Play agreement**, then click **Confirm**.',
  completeRegistration: 'Click **Complete Registration** to finish and return to the Admin Portal.',
};

const androidEmmEnrollmentText = {
  title: 'Welcome to Android EMM!',
  text: 'To register your company for Google EMM:',
  enrollmentfirstCard: enrollmentFirstCard,
  enrollmentsecondCard: enrollmentSecondCard,
  enrollmentthirdCard: enrollmentThirdCard,
  instruction: enrollmentInstructions,
  bottonText: 'Begin Enrollment',
};

const androidEmmDeleteRegistrationText = {
  title: 'Delete Registration',
  text: 'Are you sure you want to delete your Android EMM Registration?',
  alert: 'Please read before proceeding!',
  warningMessage: 'Deleting your registration cannot be undone. If you choose to proceed the following will occur, and you will need to re-enroll from the starting point.',
  enrollDeviceUnenrolled: 'Your enrolled devices will be un-enrolled (wiped and/or factory reset).',
  createdPoliciesPurged: 'Your created policies will be purged.',
  addedApplicationRemoved: 'Your added applications will be removed.',
};

const androidEmmQrEnrollmentText = {
  title: 'Enroll Your Company Owned Android Device',
  workProfile: '**Work Profile for Company Owned Device**',
  deviceVersion: '**Android 8.0 or later devices only**',
  setupDeviceTitle: 'Setting up a **company-owned device** with a\n'
    + '                **work profile** enables the device for both work and\n'
    + '                personal use. On company-owned devices with work profiles:',
  setupDeviceInfo: [
    'Most app, data, and other management policies apply to the work profile only.',
    'The employee\'s personal profile remains private. However, enterprises can enforce certain device-wide policies and personal usage policies.',
    'Enterprises can enforce compliance actions on an entire device or only its work profile.',
    'Device deletion and other commands may apply to an entire device.',
  ],
  workProfileInstructionTitle: 'To set up a **company-owned device** with a **work profile** follow the following instructions:',
  workProfileInstructionSteps: [
    'On a new or factory-reset device, tap the screen six times in the same spot. This triggers the device to prompt you to scan a QR code.',
    'Scan the QR code to start the setup. \n&nbsp;&nbsp;&nbsp;Or\n Enter the enrollment token manually to start the setup.',
    'Follow the on-screen instructions to complete the enrollment.',
  ],
  scanToEnroll: 'Scan to enroll device',
  linkText: 'Direct Link:',
};

const creatAndroidDeviceText = {
  byodTitle: 'Personal Android Devices',
  byodBody: androidEmmUserConfigText,
  selectLabel: 'Select the Device Group(s) to automatically add enrolled device to:',
  selectText: 'Device Group: <Select>',
  copeTitle: 'Company-Owned Android Devices',
  copeBody: androidEmmAdminConfigText,
};

const addAndroidAppText = {
  assign: 'and assign public, private and web applications!',
  clickToAddNew: 'Click "Add New" above to add new software to Android',
  getYourSetup: 'Let\'s get you set up! Here you can manage any apps.',
  manageDevice: 'devices, and manage here.',
  releatedTo: 'related to Google (Android/ChromeOs). You can add',
  title: 'Add your first Android APP!',
  welcomeText: 'Welcome!',
};

const applicationInstallMode = {
  availableTitle: 'Available',
  availableValue: 'AVAILABLE',
  installTitle: 'Force Install',
  installValue: 'FORCE_INSTALLED',
  blockTitle: 'Block',
  blockValue: 'BLOCKED',
};

const runtimePermissions = {
  allowTittle: 'Allow',
  allowValue: 'GRANT',
  promptTitle: 'Prompt',
  promptValue: 'PROMPT',
  denyTitle: 'Deny',
  denyValue: 'DENY',
};

const applicationUpdateMode = {
  defaultTitle: 'Default',
  defaultValue: 'AUTO_UPDATE_DEFAULT',
  priorityTitle: 'High Priority',
  priorityValue: 'AUTO_UPDATE_HIGH_PRIORITY',
  postponeTitle: 'Postpone',
  postponeValue: 'AUTO_UPDATE_POSTPONED',
};

const googleAppsDetailsText = {
  applicationInstallMode,
  applicationUpdateMode,
  runtimePermissions,
};

export default {
  addAndroidAppText,
  androidEmmAdminConfigText,
  androidEmmDeleteRegistrationText,
  androidEmmEnrollmentText,
  androidEmmRegistrationText,
  androidEmmUserConfigText,
  androidEmmQrEnrollmentText,
  creatAndroidDeviceText,
  googleAppsDetailsText,
};
